import { useRouter } from "next/router";
import {useUser} from "./useUser";

const withAuth = (WrappedComponent) => {
  return (props) => {
    const Router = useRouter();
    const [loadedSession, token] = useUser('/');

    if(!loadedSession) {
      return null;
    }

    if (token) {
      return <WrappedComponent {...props} />;
    } else {
      Router.replace("/");
      return null;
    }
  };
};

export default withAuth;
